/*
  Per-card popup used inside an Elementor Loop Grid ("event" loop item
  template). Each loop item carries its own `.project-popup-overlay`,
  hidden by default; `.open-project-popup` inside a card reveals that
  card's own overlay, `.close-popup-btn` inside the overlay hides it again.
*/

export function initProjectPopup() {
    document.addEventListener('click', function (e) {
        var openTrigger = e.target.closest('.open-project-popup');

        if (openTrigger) {
            e.preventDefault();

            var item = openTrigger.closest('.e-loop-item.event');
            var overlay = item ? item.querySelector('.project-popup-overlay') : null;

            if (overlay) {
                overlay.classList.add('is-open');
            }

            return;
        }

        var closeTrigger = e.target.closest('.close-popup-btn');

        if (closeTrigger) {
            e.preventDefault();

            var overlay = closeTrigger.closest('.project-popup-overlay');

            if (overlay) {
                overlay.classList.remove('is-open');
            }
        }
    });
}
